"use strict";
var React = require("react");

var NotificationTab = React.createClass({
    render: function() {
                    // <div className="settings-list col-md-8 col-md-offset-2">
                    //     <div className="settings-list-item clearfix">User is removed<span className="md md-check-box-outline-blank pull-right"></span></div>
                    //     <div className="settings-list-item clearfix">Equipment is added<span className="md md-check-box pull-right"></span></div>
                    //     <div className="settings-list-item clearfix">Equipment is deleted<span className="md md-check-box pull-right"></span></div>
                    //     <div className="settings-list-item clearfix">Equipment is put up for sale<span className="md md-check-box-outline-blank pull-right"></span></div>
                    //     <div className="settings-list-item clearfix">Equipment is sold<span className="md md-check-box pull-right"></span></div>
                    //     <div className="settings-list-item clearfix">Equipment is changed<span className="md md-check-box pull-right"></span></div>
                    // </div>
        return (
            <div>
                <div className="settings-header row">
                    <h3>Tilkynningar</h3>
                </div>
                <div className="settings-body clearfix">
                    <h1>Coming soon...</h1>
                </div>
            </div>
        );
    }
});

module.exports = NotificationTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Notifications/NotificationTab.react.js